import React from 'react'

const index = () => {
    return (
        <span style={{ color: 'red' }}>*</span>
    )
}

export default index